import { ApiResourceBaseClass as n } from "./baseApiCalls.js";
const t = "review_tag";
class o extends n {
  /**
   * Assign tags to reviews.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/review_tag/assign`
   *
   * @param {ReviewTagMatch | ReviewTagMatch[]} body - The data used to assign tags to reviews.
   * @returns {Promise<SuccessResponse>} A promise resolving to the response data.
   */
  assign = async (s) => {
    const { data: a } = await this.post(`${t}/assign`, s);
    return a;
  };
  /**
   * Unassign tags from reviews.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/review_tag/unassign`
   *
   * @param {ReviewTagMatch | ReviewTagMatch[]} body - The data used to unassign tags from reviews.
   * @returns {Promise<SuccessResponse>} A promise resolving to the response data.
   */
  unassign = async (s) => {
    const { data: a } = await this.post(`${t}/unassign`, s);
    return a;
  };
}
export {
  o as ReviewTag
};
